import { api } from '@/service/http';

export const getDictionary = async ( routePath, args) => {
    try {
        const { result, items, data } = await api(`${routePath}`, args);
        return result ? (items ? items : data) : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '29d31d23-75b6-45d2-8640-1c4f39719c2a',
        };
    }
};